import { dark_mode_toggled } from '../actions/types';

const INITIAL_STATE = {
  darkMode: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case dark_mode_toggled:
      return { ...state, darkMode: !state.darkMode };

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/PersonalizationReducer.js